import type { AccountHistoricalComparisonQueryArg } from '@/store/accountsApi';

interface HistoricalComparisonQueryOptions {
  startDate: string;
  endDate: string;
  groupBy: string;
  accountId?: number;
  excludedAccounts?: number[];
  excludedAccountTypes?: number[];
  excludedCategories?: number[];
  excludedInstitutions?: number[];
}

export function isCustomGroupBy(groupBy: string): boolean {
  return groupBy.startsWith('investor:') || groupBy.startsWith('advisor:');
}

function groupingFor(
  groupBy: string,
): Pick<AccountHistoricalComparisonQueryArg, 'groupConfig' | 'sort'> {
  if (isCustomGroupBy(groupBy)) {
    return {
      groupConfig: { valueProperty: groupBy, displayProperty: groupBy },
      sort: [{ property: 'PercentChange', direction: 'desc', order: 0 }],
    };
  }
  return {
    groupConfig: {
      valueProperty: 'ClassificationId',
      displayProperty: 'ClassificationName',
    },
    sort: [{ property: 'ClassificationSort', direction: 'asc', order: 0 }],
  };
}

export function historicalComparisonQueryArg({
  startDate,
  endDate,
  groupBy,
  accountId,
  excludedAccounts = [],
  excludedAccountTypes = [],
  excludedCategories = [],
  excludedInstitutions = [],
}: HistoricalComparisonQueryOptions): AccountHistoricalComparisonQueryArg {
  return {
    startDate,
    endDate,
    ...(accountId ? { accountId } : groupingFor(groupBy)),
    showAll: true,
    ...(excludedAccounts.length > 0
      ? { ExcludedAccounts: excludedAccounts }
      : {}),
    ...(excludedAccountTypes.length > 0
      ? { ExcludedAccountTypes: excludedAccountTypes }
      : {}),
    ...(excludedCategories.length > 0
      ? { ExcludedCategories: excludedCategories }
      : {}),
    ...(excludedInstitutions.length > 0
      ? { ExcludedInstitutions: excludedInstitutions }
      : {}),
  };
}
